import type { GanttDeepLink } from '../types/gantt.types'
// 딥링크(주소 컨텍스트) 읽기 — 현장·공종 숫자 판정을 한 곳에서 한다(F-20 후속: 파라미터명은 현행 siteId·taskId 만 인정, 별칭 없음).
// 호출처: 최초 진입 현장·재진입 현장·딥링크 읽기(SchedulerPage 3곳). k 는 읽지 않는다.

/** 주소에서 읽은 뒤 제거하는 키 */
export const DEEP_LINK_KEYS = ['siteId', 'taskId', 'card', 'pop'] as const

/** 양의 정수만 인정한다(0·음수·소수·문자 섞임·빈 값은 null) */
export function readPositiveId(params: URLSearchParams, key: 'siteId' | 'taskId'): number | null {
  const raw = params.get(key)
  return raw && /^\d+$/.test(raw) && Number(raw) > 0 ? Number(raw) : null
}

export type ParsedDeepLink = {
  siteId: number | null
  taskId: number | null
  card: GanttDeepLink['card']
  pop: GanttDeepLink['pop']
}

/** card·pop 의 허용값 외에는 무시한다. card 는 taskId 가 있을 때만 의미가 있다. */
export function parseDeepLink(params: URLSearchParams): ParsedDeepLink {
  const taskId = readPositiveId(params, 'taskId')
  const rawCard = params.get('card')
  const rawPop = params.get('pop')
  return {
    siteId: readPositiveId(params, 'siteId'),
    taskId,
    card: taskId !== null && (rawCard === 'pt' || rawCard === 'sup' || rawCard === 'bar' || rawCard === 'cr') ? rawCard : null,
    pop: rawPop === 'pt-assign' || rawPop === 'sup-order' || rawPop === 'ship' ? rawPop : null,
  }
}
